import { animate, group, style, transition, trigger } from '@angular/animations';

export const appear = trigger('appear', [
    transition('void => *', [
      style({opacity: 0, transform: 'translateY(-20px)'}),
      group([
        animate('400ms 200ms ease-in', style({opacity: 1})),
        animate('300ms 250ms ease-out',  style({transform: 'translateY(0)'}))
      ])
    ])
]);
